import { render, staticRenderFns } from "./batchPrescriptionAuditDialog.vue?vue&type=template&id=1d267d8f&scoped=true&"
import script from "./batchPrescriptionAuditDialog.vue?vue&type=script&lang=js&"
export * from "./batchPrescriptionAuditDialog.vue?vue&type=script&lang=js&"
import style0 from "./batchPrescriptionAuditDialog.vue?vue&type=style&index=0&id=1d267d8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d267d8f",
  null
  
)

export default component.exports